import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from 'axios';
import { axiosClient } from "../axiosClient";

export const fetchPoliciesLeadboard = createAsyncThunk("policies/leadboard", async (params: {startDate?: string, endDate?: string, timeZone: string}) => {
    const response: AxiosResponse<any> = await (await axiosClient()).get(`/policies/leadboard`, {params: {startDate: params.startDate, endDate: params.endDate, timeZone: params.timeZone}});
    return response.data
});